import { Row, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";

const SelectTypePallet = ({ value, onChange }) => {
  const [listData, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const options = [
    {
      id: "besi",
      name: "Pallet Besi",
    },
    {
      id: "kayu",
      name: "Pallet Kayu",
    },
  ];

  const getTypePallet = async () => {
    setLoading(true);
    const newData = options;
    const filteredData = newData.filter(
      (item) => !listData.find((existingItem) => existingItem.id === item.id)
    );
    setData((prevData) => [...prevData, ...filteredData]);
    setLoading(false);
  };

  useEffect(() => {
    getTypePallet();
  }, []);

  return (
    <Select
      style={{ width: "100%" }}
      showSearch
      value={value || null}
      optionFilterProp="label"
      placeholder="Pilih Tipe Pallet"
      onChange={onChange}
      notFoundContent={
        loading ? (
          <Row justify={"center"}>
            <Spin size="small" className="center" />
          </Row>
        ) : (
          "No Data"
        )
      }
      options={listData?.map((e) => ({
        label: e.name,
        value: e.id,
      }))}
    />
  );
};

export default SelectTypePallet;
